import '@fortawesome/fontawesome-free/css/all.min.css';
import FloatingVue from 'floating-vue';
import { Tooltip } from 'floating-vue';
import 'floating-vue/dist/style.css';
import moment from 'moment';
import { createApp } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import Select2 from 'vue3-select2-component';

import App from '@/app/App.vue';
import router from '@/app/app-routes';
import directiveClickOutside from '@/app/directive/click-outside.js';
import PaginationComponent from '@/app/shared/components/ui/PaginationComponent.vue';
import store from '@/app/shared/state/index';

import { configAxios } from '@/common/axios';

import './assets/theme/default/style.scss';
import tableArrow from '/plugins/table-arrow/index';

__webpack_nonce__ = window.__webpack_nonce__;

configAxios();

// Блиц не работает с хешами, поэтому после возвращения с блица подставляем хеш
const searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('code') || searchParams.has('error')) {
  const callbackQuery = searchParams.toString();
  window.history.replaceState(null, '', window.location.pathname);
  window.location.hash = `#/auth/callback?${callbackQuery}`;
}

window.$ = window.jQuery = require('jquery');
const app = createApp(App)
  .use(router)
  .use(store)
  .use(VueApexCharts)
  //стрелочки на таблицах, {speed: 45, selector: '.table-container'}
  //можно добавить опции скорость прокрутки и контейнер(стоит по умолчанию)
  .use(tableArrow)
  .use(FloatingVue);
app.component('Select-2', Select2);

app.config.globalProperties.$momentFormat = (date: moment.MomentInput, format: string) =>
  date != null ? moment(date).locale('ru').format(format) : '';
app.component('PaginationComponent', PaginationComponent);
app.component('VTooltip', Tooltip);
app.mount('#app');

app.directive('click-outside', directiveClickOutside);
